import { z } from 'zod'
import { zEmail } from '../zod-utils.js'

/**
 * Who may sign in to /admin.
 *
 * Kept in Firestore rather than in `ADMIN_EMAILS` so that adding an organiser is a
 * change an organiser can make — the deploy-time string meant every new helper cost
 * a redeploy of all nineteen functions, which is why people end up sharing one
 * login instead.
 *
 * Addresses are stored lower-cased because that is how they are compared. Google
 * hands back the address in whatever case the user typed it at sign-up.
 */
export const AdminAccessSchema = z.object({
  emails: z
    .array(zEmail)
    .min(1, 'ต้องมีผู้ดูแลอย่างน้อย 1 คน')
    .max(50, 'ผู้ดูแลได้ไม่เกิน 50 คน')
    /*
     * De-duplicated on the way in. The same address twice is harmless but it shows
     * up twice in the list, and someone then "removes" one copy and is surprised
     * that access survives.
     */
    .transform((emails) => [...new Set(emails)]),
})

export type AdminAccess = z.infer<typeof AdminAccessSchema>

export const AdminSetAdminsInputSchema = AdminAccessSchema
export type AdminSetAdminsInput = z.input<typeof AdminSetAdminsInputSchema>
